<template>
  <div class="d-flex">
    <ErrorTriangle v-if="hasErrors" class="end-date-error-triangle" :errors="params.errors" />
    <v-checkbox v-else readonly :model-value="isSelected" />
  </div>
</template>

<script>
import { useAssortmentCanvasStore } from '@/stores/assortment-canvas';
import { some } from 'lodash';
import { mapState } from 'pinia';

export default {
  computed: {
    ...mapState(useAssortmentCanvasStore, ['isConstraintSelectedToCopy']),

    isSelected() {
      const { appliedTo, constraintId } = this.params.data;
      return (
        appliedTo &&
        this.isConstraintSelectedToCopy({
          spacebreakId: appliedTo._id,
          constraintId,
        })
      );
    },

    hasErrors() {
      return some(this.params.errors, isValid => !isValid);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn {
  padding-bottom: 0 !important;
}
:deep(.v-icon) {
  font-size: 2.2rem;
}
</style>
